import {assertWixImageResource, WixImageResource} from "@wix/devzai-common-wix";
import {assertType} from "@wix/devzai-utils-common";

export type DoppeDtoFaviconSettings = {
    faviconImage: WixImageResource | null;
}

export function assertDoppeDtoFaviconSettings (wixImageResource: DoppeDtoFaviconSettings) : asserts wixImageResource is DoppeDtoFaviconSettings;
export function assertDoppeDtoFaviconSettings (wixImageResource: unknown) : asserts wixImageResource is DoppeDtoFaviconSettings;
export function assertDoppeDtoFaviconSettings (wixImageResource: unknown) : asserts wixImageResource is DoppeDtoFaviconSettings {
    assertType<DoppeDtoFaviconSettings>(wixImageResource, assert => {
        assert.isObject({
            faviconImage: assert => assert.isUnion(
                assert => assert.isNull(),
                assert => assert.usingAssertionFunction(assertWixImageResource)
            ),
        })
    })
}